import { alpha, SxProps, Theme } from '@mui/material/styles';

import { fontFamilyMonospace } from 'layout/theme';

/**
 * The tint of the running usagelog session, on its card and on its row. Gold, as LiveHighlight
 * marks live data on the unit page; a running game is not a success, so not green.
 */
export const runningTint = (theme: Theme) => alpha(theme.palette.primary.main, 0.2);

export const monoSx: SxProps<Theme> = { fontFamily: fontFamilyMonospace };

export const tabularSx: SxProps<Theme> = { fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' };

/** One line with an ellipsis; the full value is in the title and in the expand panel. */
export const singleLineMonoSx: SxProps<Theme> = {
  fontFamily: fontFamilyMonospace,
  display: 'block',
  maxWidth: { xs: '24ch', sm: '48ch', md: '72ch' },
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

/** At most two lines; the full value is in the expand panel. */
export const twoLineMonoSx: SxProps<Theme> = {
  fontFamily: fontFamilyMonospace,
  display: '-webkit-box',
  WebkitLineClamp: 2,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  wordBreak: 'break-word',
};
